import { Component } from '@angular/core';

@Component({
  selector: 'app-marketing',
  imports: [],
  templateUrl: './marketing.component.html',
  styleUrl: './marketing.component.css',
})
export class MarketingComponent {

}
